import React from "react";
import "../modal.css";
import { RiCloseLine } from "react-icons/ri";


export default class Modal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      firstName: '',
      lastName: '',
      position: '',
      team: '',
      editComplete:false,
      editFailed:false,
      editFailedMessage:'',
      madeChange:false
     }

      this.clearFields = this.clearFields.bind(this);
  }

  clearFields =() =>{
    this.setState({
      firstName: '',
      lastName: '',
      position: '',
      team: '',
    });

    console.log("cleared fields");
  }
  
  

  static getDerivedStateFromProps(props, state) {
    if(state.madeChange){
      return { 
        firstName: state.firstName,
        lastName: state.lastName,
        team: state.team,
        position: state.position 
      };
    }
     return { 
      firstName: props.playerData.nfl2kcurrentFirstName,
      lastName: props.playerData.nfl2kcurrentLastName,
      position: props.playerData.nfl2kcurrentPosition,
      team: props.playerData.nfl2kcurrentTeam
    };
  }
    
   

    onClose = e => {
      this.setState({
        editComplete: false,
        editFailed:false,
        madeChange:false
      })  
    this.props.onClose && this.props.onClose(e);
  };

  onSubmit = e => {
    e.preventDefault();
    this.updatePlayerAssignment(this.state,this.props.playerData.originalplayer);
  };

  async validSession(){
    var object = JSON.parse(localStorage.getItem("2k"));

    if(!object){
     
      this.setState({
        editFailed: true,
        editFailedMessage:"Must login to make edits."
      })
      return false;
    }
    
    var dateString = object.timestamp;
    const currentDate = new Date(); 
    const weekAgo = new Date(currentDate); 
    weekAgo.setDate(currentDate.getDate() - 7);
    var sesssionDate= new Date(dateString);
    
    if(sesssionDate > weekAgo){
            //check session id

              const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ session:object.value}) 
            };
            
          const response = await fetch('session',requestOptions);
          
          if(response.status!=200){
            this.setState({
              editFailed: true,
              editFailedMessage:"There was an error validating login."
            })
            return false;
          }

          const data = await response.json();
              console.log(data);
              return data.isValid;
    }
    else{
      
      this.setState({
        editFailed: true,
        editFailedMessage:"Must login to make edits."
      })
      return false;
    }
  }

  formValChange = e => {
    e.preventDefault();
   
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      madeChange:true
    })
  };

  checkEdit(data){
    if(data){
      this.setState({
        editComplete: true
      })
    }
    else{
      this.setState({
        editFailed: true,
        editFailedMessage:"Edit failed!"
      })
    }
  }

  

  async updatePlayerAssignment(stateUpdate,partition) {
      var session = JSON.parse(localStorage.getItem("2k"));
      const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Session-Token': session ? session.value : '' },
      body: JSON.stringify({ partition:partition,playerupdate:{FirstName:stateUpdate.firstName,LastName:stateUpdate.lastName,Position:stateUpdate.position,Team:stateUpdate.team,} }) // body data type must match "Content-Type" header
  };

    if(await this.validSession()){
     
      fetch('nflplayerassign', requestOptions)
        .then(response => {
          if(response.status===401){
            this.setState({
              editFailed: true,
              editFailedMessage:"Must login to make edits."
            })
            return null;
          }
          return response.json().then(data => this.checkEdit(data));
        });
    }
  }

  render() {

    
    if (!this.props.isOpen) {
      return null;
    }


    return <div>
       
      <div className="darkBG" />
      <div className="centered">
        <div className="playerAssignModal">
          <div className="modalHeader">
            <h5 className="heading">Assign player</h5>
          </div>
          <button className="closeBtn" onClick={this.onClose}>
            <RiCloseLine style={{ marginBottom: "-3px" }} />
          </button>
          <div className="modalContent">
            <h3>NFL 2k5 Original Player : {this.props.playerData.nfl2k5team + "- " + this.props.playerData.firstName + " " + this.props.playerData.lastName}</h3>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>First Name</label>
                <input type="text" name="firstName" value={this.state.firstName} className="form-control-modal" onChange={this.formValChange} />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input type="text" name="lastName" value={this.state.lastName}  className="form-control-modal" onChange={this.formValChange} />
              </div>
              <div className="form-group">
                <label>Position:</label>
                <input type="text" name="position" value={this.state.position} className="form-control-modal" onChange={this.formValChange} />
              </div>
              <div className="form-group">
                <label>Team:</label>
                <input type="text" name="team"  value={this.state.team} className="form-control-modal" onChange={this.formValChange} />
              </div>
               <button type="button" className="cancelBtn" onClick={this.clearFields}>Clear Fields</button>
              <button type="submit" className="submitBtn">Submit Edit</button>
              <button className="cancelBtn" onClick={this.onClose}>Cancel</button>
              { this.state.editComplete ? <div className="edit-success">Edit Completed!</div> : null }
              { this.state.editFailed ? <div className="edit-fail">{this.state.editFailedMessage}</div> : null }
            </form>
          </div>
        </div>
      </div>
    </div>
  }
}



